<div class="ui-image-gallery">
  @if (slides().length > 1) {
    <div class="ui-image-gallery__rail">
      <div class="ui-image-gallery__thumbs" role="list">
        @for (slide of slides(); track slide.src; let index = $index) {
          <button
            type="button"
            class="ui-image-gallery__thumb"
            [class.ui-image-gallery__thumb--active]="normalizedIndex() === index"
            [attr.aria-label]="'Mostrar ' + thumbAlt(slide, index)"
            [attr.aria-current]="normalizedIndex() === index ? 'true' : null"
            (click)="setActiveIndex(index)"
          >
            <img
              class="ui-image-gallery__thumb-image"
              [src]="slide.src"
              [alt]="thumbAlt(slide, index)"
            />
          </button>
        }
      </div>
    </div>
  }

  <div
    class="ui-image-gallery__stage"
    (pointerdown)="onSwipeStart($event)"
    (pointerup)="onSwipeEnd($event)"
    (pointercancel)="onSwipeEnd($event)"
  >
    <div
      class="ui-image-gallery__reel"
      [class.ui-image-gallery__reel--pair]="incomingIndex() !== null"
      [class.ui-image-gallery__reel--next]="
        incomingIndex() !== null && direction() === 'next'
      "
      [class.ui-image-gallery__reel--prev]="
        incomingIndex() !== null && direction() === 'prev'
      "
      [class.ui-image-gallery__reel--run]="pushing()"
      (transitionend)="onPushEnd($event)"
    >
      @for (frame of frames(); track frame.index) {
        <div class="ui-image-gallery__frame">
          @if (mainImageInteractive()) {
            <button
              type="button"
              class="ui-image-gallery__image-button"
              aria-label="Ver imagen en pantalla completa"
              (click)="activateMainImage()"
            >
              <img
                class="ui-image-gallery__image"
                [src]="frame.slide.src"
                [alt]="frameAlt(frame.slide, frame.index)"
              />
            </button>
          } @else {
            <img
              class="ui-image-gallery__image"
              [src]="frame.slide.src"
              [alt]="frameAlt(frame.slide, frame.index)"
            />
          }
        </div>
      }
    </div>

    @if (mobileNavigation() && slides().length > 1) {
      <button
        type="button"
        class="ui-image-gallery__navigation ui-image-gallery__navigation--previous"
        aria-label="Imagen anterior"
        (click)="previous()"
      >
        <svg
          class="ui-image-gallery__navigation-icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M14.5 6.5 9 12l5.5 5.5"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <button
        type="button"
        class="ui-image-gallery__navigation ui-image-gallery__navigation--next"
        aria-label="Imagen siguiente"
        (click)="next()"
      >
        <svg
          class="ui-image-gallery__navigation-icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M9.5 6.5 15 12l-5.5 5.5"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    }
  </div>
</div>
